import {
  Chip,
  ListItem,
  ListItemIcon,
  ListItemText,
  Paper,
  Stack,
} from "@mui/material";
import React, { useCallback } from "react";
import { Body1, Body2, Icone } from "../../../components";
import {
  getColorStatusCashback,
  getStatusCashback,
  getTitleStatusCashback,
  sendMessageWhatsApp,
} from "./cashback-utils";
import { useDispatch, useSelector } from "react-redux";
import { cashbackSetModal } from "./reducers/cashback-actions";
import OptionsMenu from "../../../extra-components/options-menu";
import CashbackModal from "./cashback-modal";
import { selectIsAdminVoucher } from "./cashback-selectors";

const STR = {
  nameClient: "Cliente",
  valueVoucher: "Cashback",
  datePraz: "Prazo para resgate",
  labelView: "Ver detalhes",
  labelSendMessage: "Enviar mensagem",
  labelUpdateClient: "Atualizar cliente",
  labelDelete: "Excluir Cashback",
};

function CashbackItemMobile(props) {
  return (
    <Paper sx={{ p: 1, my: 0.5 }}>
      <ListItem
        secondaryAction={
          <Options
            id={props.id}
            cellPhone={props.cellPhone}
            name={props.nameClient}
          />
        }
      >
        <ListItemIcon>
          <Icone
            title={getTitleStatusCashback(props.status)}
            icone={getStatusCashback(props.status)}
            color={getColorStatusCashback(props.status)}
          />
        </ListItemIcon>
        <ListItemText
          primary={`${STR.valueVoucher} - ${props.valueVoucher}`}
          secondary={
            <Stack>
              <Body1>
                {STR.nameClient} - {props.nameClient}
              </Body1>
              <Stack sx={{ mt: 1 }} direction="row" alignItems="center" gap={1}>
                <Body2>{STR.datePraz}</Body2>
                <Chip size="small" label={props.datePraz} color="info" />
              </Stack>
            </Stack>
          }
        />
      </ListItem>
    </Paper>
  );
}

const Options = ({ id, cellPhone, name }) => {
  const isAdmin = useSelector(selectIsAdminVoucher);
  const dispatch = useDispatch();

  //
  const onView = useCallback(() => {
    dispatch(
      cashbackSetModal({
        type: CashbackModal.modal.VIEW,
        data: {
          id,
        },
      })
    );
  }, [dispatch, id]);

  const onSendMessage = useCallback(() => {
    sendMessageWhatsApp(id, cellPhone);
  }, [cellPhone, id]);
  //
  const onUpdateClient = useCallback(() => {
    dispatch(
      cashbackSetModal({
        type: CashbackModal.modal.UPDATE_CLIENT,
        data: {
          id,
          name,
          cellPhone,
        },
      })
    );
  }, [dispatch, id, name, cellPhone]);
  //
  const onDeleteCashback = useCallback(() => {
    dispatch(
      cashbackSetModal({
        type: CashbackModal.modal.DELETE_CASHBACK,
        data: {
          id,
        },
      })
    );
  }, [dispatch, id]);

  //
  const options = [
    {
      icon: "Visibility",
      label: STR.labelView,
      onClick: onView,
    },
    {
      icon: "WhatsApp",
      label: STR.labelSendMessage,
      onClick: onSendMessage,
    },
    {
      icon: "Edit",
      label: STR.labelUpdateClient,
      onClick: onUpdateClient,
    },
  ];
  if (isAdmin) {
    options.push({
      icon: "Delete",
      label: STR.labelDelete,
      onClick: onDeleteCashback,
    });
  }
  return <OptionsMenu options={options} />;
};

export default CashbackItemMobile;
